import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=6d4caea1&scoped=true"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=6d4caea1&prod&lang=less"
import style1 from "./ShowAnnouncement.vue?vue&type=style&index=1&id=6d4caea1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4caea1",
  null
  
)

export default component.exports